import * as React from 'react';
import * as HmiFiles from '../../../hmilib/hmifiles';
import '../../../hmilib/hmiglobal';
import LoadPage from './../../LoadPage';
import './CENTUMVP.css';
import LeftMenu from './LeftMenu';
import TopMenu from './TopMenu';

import { prefbase } from 'components/hmilib/hmiclientbase';
import { observer } from 'mobx-react-lite';
import { useEffect } from 'react';
import { useStores } from 'store';
import { TypeSystemEnum } from '../../../hmilib/hmiglobal';
import OperatorGuideMessage from './components/Alarm/OperatorGuideMessage';
import ProcessAlarm from './components/Alarm/ProcessAlarm';
import SystemAlarmMassage from './components/Alarm/SystemAlarmMassage';
import PortableWindowManager from './components/PortableWindow/PortableWindowManager';
import MainFrameTab from './components/Tabs/MainFrameTab';
import MainWindowTab from './components/Tabs/MainWindowTab';
import './components/Tabs/tab-style.css';
import { Context } from './ContextVP';

interface imain {}
export interface dataTreeDTO {
    id: string;
    pid: string;
    subname: string;
}

const AlarmTree = {
    mnemonicDiagrams: {
        PROCESS_ALARM: {
            name: '.AL Process Alarm',
            icon: '/ixyber/vision/static/images/tree_icon/centum_process_alarm.jpg',
            description: 'alarm',
            path: 'SYSTEM/PROCESS_ALARM'
        },
        OPERATOR_GUIDE_MESSAGE: {
            name: '.OG Operator Guide Message',
            icon: '/ixyber/vision/static/images/tree_icon/centum_operator_guide_message.jpg',
            description: 'alarm',
            path: 'SYSTEM/OPERATOR_GUIDE_MESSAGE'
        },
        SYSTEM_STATUS_OVERVIEW: {
            name: '.SO System Status Overview',
            icon: '/ixyber/vision/static/images/tree_icon/centum_system_status_overview.jpg',
            description: 'alarm',
            path: 'SYSTEM/SYSTEM_STATUS_OVERVIEW',
            mnemonicDiagrams: {
                SH_HIS_SETUP: {
                    name: '.SH HIS Setup',
                    icon: '/ixyber/vision/static/images/tree_icon/centum_his_setup.jpg',
                    description: 'alarm',
                    path: 'SYSTEM/SYSTEM_STATUS_OVERVIEW/SH_HIS_SETUP'
                },
                SYSTEM_ALARM_MESSAGE: {
                    name: '.SA System Alarm Message',
                    icon: '/ixyber/vision/static/images/tree_icon/centum_system_alarm_message.jpg',
                    description: 'alarm',
                    path: 'SYSTEM/SYSTEM_STATUS_OVERVIEW/SYSTEM_ALARM_MESSAGE'
                }
            }
        },
        PROCESS_REPORT: {
            name: '.PR Process Report',
            icon: '/ixyber/vision/static/images/tree_icon/centum_process_report.jpg',
            description: 'alarm',
            path: 'SYSTEM/PROCESS_REPORT'
        }
    },
    name: 'SYSTEM',
    icon: '/ixyber/vision/static/images/tree_icon/centum_user_icon.jpg',
    path: 'SYSTEM'
};

declare global {
    interface Window {
        CentumTrendsTree: any; // Use a more specific type if possible
    }
}

const Main = (props: imain) => {
    // const Context = React.createContext(null);
    const { SystemStore } = useStores();
    const [loadstate, setLoadState] = React.useState(false);
    //Полный обьект дерава
    const [dataTree, setDataTree] = React.useState<any>();
    const [dataTrendsTree, setDataTrendsTree] = React.useState<any>();
    //Упрощенный обьект дерева для поиска открытой мнемосхемы
    const [dataTreeDTO, setDataTreeDTO] = React.useState<any>({});
    //Последняя открытая мнемосхема
    const [selectedElem, setSelectedElem] = React.useState<dataTreeDTO>();
    //Сохранение имени последней открытой мнемосхемы
    const [nameMnemo, setNameMnemo] = React.useState<string>('');
    //
    const [shConfig, setShConfig] = React.useState();

    //Сохранение текущего блока
    const [curItem, setCurItem] = React.useState<string>('');
    const [mnemoInfoToSave, setMnemoInfoToSave] = React.useState({
        mnemoname: '',
        item: '',
        subname: '',
        binding: ''
    });
    // рефы
    const mainWindowRef = React.useRef<any>(null);
    const [showIframeTab, setShowIframeTab] = React.useState<boolean>(false);

    React.useEffect(() => {
        const pagename = 'CentumVP';

        window.TypeSystem = TypeSystemEnum.CentumVP;

        document.title = pagename;

        return function clear() {
            HmiFiles.CloseAll();
        };
    }, []);

    useEffect(() => {
        if (SystemStore.loadState) {
            setLoadState(true);
        }
    }, [SystemStore.loadState]);

    React.useEffect(() => {
        let data: any[] = [];
        //Получаем обьект дерева
        fetch(window.hostdata + '/Base/GetObject?path=MNEMONICDIAGRAMFOLDER')
            .then((res) => res.json())
            .then((res: any) => {
                data = [res, AlarmTree];
                setDataTree(data);
                GetDataTreeDTO(data[0]);
                setDataTreeDTO(dict);
            });

        // console.log(prefbase);

        return function clear() {};
    }, []);

    //Поиск и открытие всех мнесосхем, для поиска тeгов
    React.useEffect(() => {
        if (!isEmpty(dataTreeDTO)) {
            Object.keys(dataTreeDTO).forEach((key) => {
                const subname = dataTreeDTO[key].subname;

                if (subname) {
                    if (!subname.includes('Block')) {
                        window.Base.Events.MnemoAlarms(key).Top[0];
                    }
                }
            });
        }
    }, [dataTreeDTO]);

    React.useEffect(() => {
        let data: any[] = [];

        if (prefbase != '') {
            // console.log(prefbase)
            fetch(window.hostdata + `/Base/GetObject?path=${prefbase}/TRENDS`)
                .then((res) => res.json())
                .then((res: any) => {
                    data = [res];
                    setDataTrendsTree(data);
                    window.CentumTrendsTree = data;
                });
        }
    }, [prefbase]);

    //Sh config
    React.useEffect(() => {
        const urlSh = '/ixyber/vision/dcs/centumvp/sh.json';

        const ShSettings = localStorage.getItem('ShSettings');

        if (!ShSettings) {
            fetch(urlSh)
                .then((response) => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.json();
                })
                .then((data) => {
                    localStorage.setItem('ShSettings', JSON.stringify(data));
                    setShConfig(data);
                })
                .catch((error) => {});
        } else {
            setShConfig(JSON.parse(ShSettings));
        }
    }, []);

    const isEmpty = (obj: any) => {
        for (let key in obj) {
            return false;
        }
        return true;
    };

    let dict: { [key: string]: dataTreeDTO } = {};

    //функция для записи всех элементов дерева в один обект без вложенности
    function GetDataTreeDTO(data: any) {
        dict[data.name] = { id: data.id, pid: data.pid, subname: data.subname };

        if (!isEmpty(data.mnemonicDiagrams)) {
            for (let mKey in data.mnemonicDiagrams) {
                GetDataTreeDTO(data.mnemonicDiagrams[mKey]);
            }
        }
    }

    //Сохранение id и pid для перемещения в ToolButton
    function handleNameInputChange(namemnemo: any, close: boolean = false, item?: string) {
        setNameMnemo(namemnemo);
        if (item) setCurItem(item);
        if (namemnemo == '') {
            setShowIframeTab(false);
            clearIframeContents('mainframe');
        }
    }

    const clearIframeContents = (iframeId: string) => {
        const iframe = document.getElementById(iframeId) as HTMLIFrameElement;

        if (iframe) {
            const iframeDocument = iframe.contentDocument;

            if (iframeDocument) {
                const bodyElement = iframeDocument.querySelector('body');

                if (bodyElement) {
                    // props.onNameInputChange("")
                    bodyElement.innerHTML = '';
                }
            }
        }
    };

    React.useEffect(() => {
        const pid =
            dataTreeDTO[nameMnemo] && dataTreeDTO[nameMnemo].pid !== undefined ? dataTreeDTO[nameMnemo].pid : '';
        const id = dataTreeDTO[nameMnemo] && dataTreeDTO[nameMnemo].pid !== undefined ? dataTreeDTO[nameMnemo].id : '';

        setSelectedElem({
            pid: pid,
            id: id,
            subname: ''
        });
    }, [nameMnemo]);

    // рендер компонентов аларма
    let componentToRender;

    switch (nameMnemo) {
        case '.AL Process Alarm':
            componentToRender = (
                <div id="main-window" className="centumvp-main" style={{ marginBottom: '1000px' }}>
                    <ProcessAlarm visible={true} />
                </div>
            );
            break;
        case '.SA System Alarm Message':
            componentToRender = (
                <div id="main-window" className="centumvp-main" style={{ marginBottom: '1000px' }}>
                    <SystemAlarmMassage visible={true} />
                </div>
            );
            break;
        case '.OG Operator Guide Message':
            componentToRender = (
                <div id="main-window" className="centumvp-main" style={{ marginBottom: '1000px' }}>
                    <OperatorGuideMessage visible={true} />
                </div>
            );
            break;
        default:
            componentToRender = <></>;
    }

    const [observer, setObserver] = React.useState<MutationObserver | null>(null);

    //Отслеживаем изменения внутри фрейма
    React.useEffect(() => {
        const intervalId = setInterval(() => {
            const mainDiv = document.getElementById('main-window');
            if (mainDiv && !observer) {
                const newObserver = new MutationObserver((mutationsList) => {
                    for (const mutation of mutationsList) {
                        if (mutation.type === 'childList') {
                            getInfoFromSvg(dataTreeDTO);
                        }
                    }
                });

                const config = { childList: true, subtree: true };
                newObserver.observe(mainDiv, config);
                setObserver(newObserver);
            }
        }, 100);

        return () => {
            clearInterval(intervalId);
            if (observer) {
                observer.disconnect();
            }
        };
    }, [observer, dataTreeDTO]);

    const getInfoFromSvg = (dataTreeDTO: any) => {
        const iframe = document.getElementById('mainframe') as HTMLIFrameElement;
        if (iframe) {
            const iframeDocument = iframe.contentDocument;
            if (iframeDocument) {
                const svgElement = iframeDocument.querySelector('svg');
                const mnemoinfoValue = svgElement?.getAttribute('data-mnemoinfo');
                if (mnemoinfoValue) {
                    try {
                        const jsonMnemoinfo = JSON.parse(mnemoinfoValue);

                        if (jsonMnemoinfo && jsonMnemoinfo.file) {
                            const MnemoName: string = jsonMnemoinfo.file;
                            let Binding: string = '';
                            let SubName: string = '';

                            if (MnemoName === 'TuningVP') {
                                const regex = /SELECT=([^&]+)/;
                                const match = jsonMnemoinfo.bindings.match(regex);
                                match ? (Binding = match[1]) : (Binding = '');
                            } else if (MnemoName.includes('CentumVPTrends')) {
                                Binding = jsonMnemoinfo.bindings;
                            }

                            if (MnemoName !== null && MnemoName !== undefined) {
                                if (MnemoName.includes('CentumVPTrends')) {
                                    const GroupToOpen = new URLSearchParams(Binding);
                                    const Block = GroupToOpen.get('BLOCK')?.toLocaleLowerCase() || '';
                                    const Group = GroupToOpen.get('GROUP')?.toLocaleLowerCase() || '';

                                    const blockFormat = formatValue(Block.replace(/\D/g, ''), 'Block');
                                    const groupFormat = formatValue(Group.replace(/\D/g, ''), 'Group');

                                    SubName = findSubnameByName(dataTreeDTO, MnemoName, blockFormat, groupFormat);

                                    setMnemoInfoToSave({
                                        mnemoname: `${Block} ${Group}`,
                                        item: 'CentumVPTrends',
                                        subname: SubName,
                                        binding: Binding
                                    });
                                    handleNameInputChange(`Trends ${Block} ${Group}`);
                                    setShowIframeTab(false);
                                } else {
                                    SubName = findSubnameByName(dataTreeDTO, MnemoName);
                                    setMnemoInfoToSave({
                                        mnemoname: MnemoName,
                                        item: '',
                                        subname: SubName,
                                        binding: ''
                                    });
                                    handleNameInputChange(MnemoName);
                                    setShowIframeTab(true);
                                }
                            }
                        }
                    } catch (error) {
                        console.log(mnemoinfoValue);
                    }
                }
            }
        }
    };

    function formatValue(value: string, type: 'Block' | 'Group'): string {
        return `${type}:${value.padStart(2, '0')}`;
    }

    const findSubnameByName = (data: any, nameToFind: string, block?: string, group?: string): string => {
        let result = '';

        if (nameToFind.includes('CentumVPTrends')) {
            const tempdata: dataTreeDTO = data;
            Object.entries(tempdata).forEach(([key, value]) => {
                if (value.subname && block && group) {
                    if (
                        value.subname.toUpperCase().includes(block.toUpperCase()) &&
                        value.subname.toUpperCase().includes(group.toUpperCase())
                    ) {
                        result = value.subname;
                        return result;
                    }
                }
            });
        } else {
            const foundItem = data[nameToFind];
            if (foundItem && foundItem.subname) {
                result = foundItem.subname;
            }
        }

        return result;
    };

    return (
        <>
            {!loadstate ? (
                <LoadPage visible={true} />
            ) : (
                <Context.Provider value={{ dataTrendsTree, shConfig }}>
                    <div className="centumvp" style={{ userSelect: 'none' }}>
                        <TopMenu />

                        <LeftMenu
                            mainWin={mainWindowRef}
                            dataTree={dataTree}
                            dataTrendsTree={dataTrendsTree}
                            selectedElem={selectedElem}
                        />
                        <div ref={mainWindowRef} className="centumvp-window">
                            <MainWindowTab
                                shConfig={shConfig}
                                onNameInputChange={handleNameInputChange}
                                allMnemos={dataTreeDTO}
                                mnemoInfoToSave={mnemoInfoToSave}
                            />
                            {componentToRender}
                            <div id="main-window" className="centumvp-main">
                                {showIframeTab && <MainFrameTab namemnemo={mnemoInfoToSave.mnemoname} />}
                                <div
                                    style={{ height: showIframeTab ? 'calc(100% - 30px)' : '100%' }}
                                    className="frame-container">
                                    <iframe id="mainframe" name="mainframe" className="centumvp-main__frame"></iframe>
                                </div>
                            </div>
                        </div>
                        <PortableWindowManager />
                    </div>
                </Context.Provider>
            )}
        </>
    );
};

export default observer(Main);
